import React, {useState} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import * as GroupGameService from "../../api/GroupGameService";
import {EditGroupGamesPage} from "./EditGroupGamesPage";
import cabinetStyle from "./MentorCabinet.module.css";
import {trySetTimeout} from "../../hooks/trySetTiemout";
import {useTranslation} from "react-i18next";

function EditGroupGameModalWindow(props) {
    const [isSaved, setIsSaved] = useState(false)
    const [saveDisabled, setSaveDisabled] = useState(true)
    const [gameName, setGamerName] = useState(props.gameName)
    const [selectedStyle, setSelectedStyle] = useState(props.selectedStyle)
    const [selectedDeck, setSelectedDeck] = useState(props.selectedDeckId + "-" + props.selectedDeckType)
    const [players, setPlayers] = useState(props.players)
    const [priceDelta, setPriceDelta] = useState(0)
    const { t } = useTranslation('translation', { keyPrefix: 'editGameModal' });

    const initialPlayersNumber = props.players.length

    function prepPlayer() {
        return players.map(player => {
            return {
                id: player.identifier,
                status: player.status,
                name: player.playerName,
                is_auto_dice: player.isAutoDice,
                chip_char: player.chipName,
                chip_color: player.color
            }
        })
    }

    function changeButton() {
        setIsSaved(true)
        trySetTimeout(() => {
            setIsSaved(false)
            props.onClose()
        }, 1500)
    }

    function updateGroupGame() {
        GroupGameService.postUpdateGroupGame(
            props.gameId,
            gameName,
            selectedStyle,
            selectedDeck.split("-")[0],
            selectedDeck.split("-")[1],
            prepPlayer(),
            priceDelta * 100,
            () => {
                props.updateGames()
                props.updateBalance()
                changeButton()
            },
            () => window.alert(t('errorMessage'))
        )
    }

    function resolePriceDeltaForUI() {
        if (priceDelta > 0) {
            return "+" + priceDelta
        } else if (priceDelta < 0) {
            return priceDelta
        } else {
            return "+" + priceDelta
        }
    }

    return (
        <Modal
            show={true}
            onHide={props.onClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader closeButton>
                <ModalTitle>{t('editGame')}</ModalTitle>
            </ModalHeader>
            <ModalBody style={{backgroundColor: "white"}}>
                <EditGroupGamesPage gameName={gameName}
                                    players={players}
                                    selectedStyle={selectedStyle}
                                    selectedDeck={selectedDeck}
                                    setSaveDisabled={setSaveDisabled}
                                    setGamerName={setGamerName}
                                    setSelectedStyle={setSelectedStyle}
                                    setSelectedDeck={setSelectedDeck}
                                    setPlayers={setPlayers}
                                    initialPlayersNumber={initialPlayersNumber}
                                    currentBalance={props.currentBalance}
                                    setPriceDelta={setPriceDelta}
                                    freeTier={props.freeTier}
                                    videoAllowed={props.videoAllowed}
                ></EditGroupGamesPage>
            </ModalBody>

            <ModalFooter>
                <Button variant="primary" onClick={props.onClose} style={{backgroundColor: "#7749F8"}}>
                    {t('closeButton')}
                </Button>
                <Button variant="primary"
                        style={{
                            display: "grid",
                            gridTemplateColumns: !props.require_payment ? "1fr 1fr" : "1fr",
                            justifyContent: "center",
                            gap: "6",
                            backgroundColor: isSaved ? "green" : "#7749F8",
                        }}
                        disabled={saveDisabled}
                        onClick={updateGroupGame}>
                    <div>
                        {isSaved ? t('savedButton') : t('saveButton')}
                    </div>
                    {!props.require_payment && <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            alignItems: "center",
                        }}
                    >{resolePriceDeltaForUI()}
                        <div className={cabinetStyle.coinSmall}/>
                    </div>}
                </Button>
            </ModalFooter>
        </Modal>
    )

}

export default EditGroupGameModalWindow